import React, { useState, useEffect } from 'react';
import { TextField } from '@material-ui/core';
import styled from 'styled-components';
import config from '../../config';

const StyledTextField = styled(TextField)`
  .MuiOutlinedInput-notchedOutline {
    border-radius: 0;
    border: 0;
  }
  .MuiOutlinedInput-input {
    background: ${config.styles.colors.inputHighlight};
  }
`;

export const UIDataTableBodyCellRecordFieldEditableDouble = ({
  fieldValue,
  handleFieldChange
}) => {
  const [value, setValue] = useState(0);
  const [timer, setTimer] = useState(null);

  const timeoutWrapper = newValue => {
    return () => {
      if (newValue === '') {
        return;
      }
      const normalizedNewValue = isNaN(newValue) ? 0 : parseFloat(newValue);

      handleFieldChange(normalizedNewValue);
    };
  };

  useEffect(() => {
    setValue(fieldValue);
  }, [fieldValue]);

  return (
    <StyledTextField
      value={value}
      type="number"
      variant="outlined"
      style={{
        padding: '3px',
        background: '#fff'
      }}
      onChange={event => {
        clearTimeout(timer);
        setValue(event.target.value);
        setTimer(setTimeout(timeoutWrapper(event.target.value), 300));
      }}
    />
  );
};

export default UIDataTableBodyCellRecordFieldEditableDouble;
